import { useMutation } from '@apollo/client'
import { removePage as removePageGql }
   from 'src/graphql/mutations/removePage.gql'

const useRemovePage = (mutationHookOptions = {}) => {
   const [removePage, { called, client, data, error, loading }] =
      useMutation(removePageGql, mutationHookOptions)

   const wrappedMutationFn = (variables, mutationFnOptions) => removePage({
      variables,
      ...mutationFnOptions
   })

   return {
      removePage: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useRemovePage
